<template>
    <v-container fluid>
        <!-- Project name -->
        <v-col :alvqa="alvqa + '-title'">
            <v-row class="pl-4 headline">
                {{ item.title }}
            </v-row>
        </v-col>

        <!-- Details (v-cards) -->
        <v-row class="pl-4 pr-4">
            <v-col v-if="item.tag !== null">
                <v-card elevation="0">
                    <v-card-text>
                        <!-- Tags -->
                        <div
                            class="read-only-caption"
                            :alvqa="alvqa + '-caption-tags'"
                        >{{ $t('lang_GENERIC_CAPTION_TAGS') }}:</div>
                        <div
                            
                            :alvqa="alvqa + '-tags'"
                        >{{ item.tag }}</div>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col v-if="item.note !== null">
                <v-card elevation="0">
                    <v-card-text>
                        <!-- Tags -->
                        <div
                            class="read-only-caption"
                            :alvqa="alvqa + '-caption-note'"
                        >{{ $t('lang_GENERAL_CAPTION_NOTES') }}:</div>
                        <div
                            
                            :alvqa="alvqa + '-note'"
                        >{{ item.note }}</div>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <!-- Panels -->
        <v-row>
            <v-col class="ml-4 mr-4">
                <v-expansion-panels multiple focusable tile flat>
                    <LabelProjectsReleasesReadOnlyPanel :projectsAlvId="item.alvId" />
                    <ProjectsProfitAndLossReadOnlyPanel :projectsAlvId="item.alvId" />
                </v-expansion-panels>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import LabelProjectsReleasesReadOnlyPanel from './_panels/1_releases/LabelProjectsReleasesReadOnlyPanel'
import ProjectsProfitAndLossReadOnlyPanel from './_panels/2_profitAndLoss/ProjectsProfitAndLossReadOnlyPanel'

export default {
    name: 'LabelProjectsReadOnly',
    components: {
        LabelProjectsReleasesReadOnlyPanel,
        ProjectsProfitAndLossReadOnlyPanel
    },
    data() {
        return {
            alvqa: 'label-releases-list-read-only'
        }
    },
    computed: {
        item() { return this.$store.getters.getExpandedLabelProjects[0] },
    }
}
</script>